import {Component} from '@angular/core';
import {ActivatedRoute} from '@angular/router';

/**
 * Hosts the business pages. A logged-in member gets them inside the profile layout (the side menu stays, like the
 * profile, events and blogs); a visitor who is not logged in gets the same page on a plain layout, since the directory
 * is public to browse. Which page to show comes from the route's `routedView` data.
 */
@Component({
    selector: 'app-biz-host',
    templateUrl: './biz-host.component.html'
})
export class BizHostComponent {
    readonly loggedIn = sessionStorage.getItem('username') !== null;
    readonly view: string;

    constructor(route: ActivatedRoute) {
        this.view = route.snapshot.data['routedView'] ?? 'bizList';
    }
}
